import { Button, Input } from 'antd';
import * as React from 'react';

interface IMailchimpResponse {
    status: 'sending' | 'success' | 'error' | null;
    message: string | Error | object | null;
    [key: string]: any; // Allows for other potential properties
}

export const MailChimpNewsletter = ({ status, message, onValidated }: IMailchimpResponse) => {
    const [email, setEmail] = React.useState('');
    // const [firstName, setFirstName] = React.useState('');

    const handleSubmit = (e:any) => {
        e.preventDefault();
        return email &&
        // firstName &&
        email.indexOf("@") > -1 &&
        onValidated({
          EMAIL: email,
          // FNAME: firstName
        });
    }

    const submit = (e:any) => handleSubmit(e);  
    
    // const nameonchange = (event:React.ChangeEvent<HTMLInputElement>)=>setFirstName(event.target.value);
    const emailOnChange = (event:React.ChangeEvent<HTMLInputElement>)=>setEmail(event.target.value);

    React.useEffect(() => {
        console.log(status)
        if(status === "success") {clearFields();}
    }, [status])

    const clearFields = () => {
        // setFirstName('');
        // setLastName('');
        setEmail('');
    }

    return (
        <form className="mc__form" onSubmit={submit}>
        <h3 className="mc__title">SIGN UP TO GET BRAND UPDATES</h3>
        {status === "sending" && (
          <div className="mc__alert mc__alert--sending">
            sending...
          </div>
        )}
        {status === "error" && (
          <div 
            className="mc__alert mc__alert--error"
            dangerouslySetInnerHTML={{ __html: message as string || ''}}
          />
        )}
        {status === "success" && (
          <div
            className="mc__alert mc__alert--success"
            dangerouslySetInnerHTML={{ __html:message as string || ''  }}
          />
        )}
        <div className="mc__field-container">
          <div>
            <Input
              value={email}
              onChange={emailOnChange}
              type="email"
              placeholder="Your email"
            />
          </div>
          <div>
            <Button htmlType="submit" className='submitFooterNewsletter'>
                Submit
            </Button>
          </div>
        </div>
      </form>
    );
};